import { render } from "./OkIcon.vue?vue&type=template&id=8bc5b6fa"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/OkIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8bc5b6fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8bc5b6fa', __exports__)) {
    api.reload('8bc5b6fa', __exports__)
  }
  
  module.hot.accept("./OkIcon.vue?vue&type=template&id=8bc5b6fa", () => {
    api.rerender('8bc5b6fa', render)
  })

}


export default __exports__